// import BlackPlus from "../../../assets/icons/Black_Plus_icon.svg?react"
// import BlackMic from "../../../assets/icons/Black_Mic.svg?react"
import { ReactComponent as SendIcon } from "../../../assets/icons/Service Request Flow/sendIcon.svg";
import "./commentInputStyle.css";
// import UploadImageModal from "../../Modal/UploadImageModal"
import { forwardRef, useImperativeHandle, useEffect, useRef, useState } from "react";
import fullImage from "../../../assets/img/NS-00041.jpg";
// import { formatDateTime } from "../../../utils/formatDateAndTime"
import { useGlobalContext } from "../../../context/GlobalContext";
import { CircularProgress, Grow, IconButton, Modal } from "@mui/material";
import { useLocation, useParams } from "react-router-dom";
// import { usePostComment } from "../../../api/comment"
import { useMutation, useQueryClient } from "@tanstack/react-query";
// import { runingFormatTime } from "../../../utils/formatTimeFromMilliSecond"
// import { newGetIcons } from "../../../utils/newGetIcons"
import { ReactComponent as BigCrossIcon } from "../../../assets/icons/update_img_icons/cross.svg";
import MesaageModal from "../Modal";
import { getIcon } from "utils/iconsConfig";
import FileContainerComp from "../UploadImageModal/FileContainerComp";
import TableContainerComp from "../UploadImageModal/TableContainerComp";
import { postServiceComment, usePostComment } from "features/Setting/Service Request/API/getAllServiceRequest";
import { useGetFileToS3link } from "./getFileToS3linkAPI";

export const runingFormatTime = (seconds) => {
  const m = Math.floor(seconds / 60)
    .toString()
    .padStart(2, "0");
  const s = (seconds % 60).toString().padStart(2, "0");
  return `${m}:${s}`;
};

const CommentComp = forwardRef(
  (
    {
      isFileUpload = true,
      hideSend = false,
      initialComment = "",
      onRecordingChange,
      setOpenUploadImage,
      mode,
      isRecordOnly = false,
      hidePlaceholder = false,
      /** When true with mode "audio", keep recording as File + blob preview; do not call S3 (e.g. Create Modification sends file on submit). */
      skipVoiceS3Upload = false,
      ...props
    },
    ref
  ) => {
  const [imageModal, setImageModal] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [commentText, setCommentText] = useState(initialComment);
  const [isRecording, setIsRecording] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [recordingTime, setRecordingTime] = useState(0);
  const [recordedAudio, setRecordedAudio] = useState(null);
  const [isRecordingFinished, setIsRecordingFinished] = useState(false);
  const timerRef = useRef(null);
  const textareaRef = useRef(null);
  const prevHeightRef = useRef(0);
  const [trackHeight, setTrackHeight] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [mentionList, setMentionList] = useState([]);
  const [showMentionBox, setShowMentionBox] = useState(false);
  const [mentionSearch, setMentionSearch] = useState("");
  const [emojiList, setEmojiList] = useState([]);
  const [selectedMentionIndex, setSelectedMentionIndex] = useState(-1);
  const [selectedEmojiIndex, setSelectedEmojiIndex] = useState(-1);

  const { setScrollToBottomTrigger, setAlert } = useGlobalContext();
  const location = useLocation();
  const Id = location.pathname.split("/")[2];
  const queryClient = useQueryClient();
  const { serviceRequestId } = useParams();
  // const { isPending, isSuccess, mutate } = usePostComment();
  const { isPending, isSuccess, mutate } = useMutation({
    mutationFn: postServiceComment,
    onSuccess: () => {
      queryClient.invalidateQueries(["serviceComment"]);
    },
  });

  const { mutate: generateS3link } = useGetFileToS3link();

  // Handle image submission
  const handleImageSumbit = () => {
    if (!uploadedFiles || uploadedFiles.length === 0) {
      // setAlert({
      //   alertMessage: "Please select an image before submitting",
      //   alertVisible: true,
      //   alertType: "warning",
      // });
      return;
    }

    // Check if all files are images
    const hasNonImage = uploadedFiles.some((file) => !file.type.startsWith("image/"));

    if (hasNonImage) {
      // setAlert({
      //   alertMessage: "Only image files are allowed (PNG, JPG, JPEG)",
      //   alertVisible: true,
      //   alertType: "error",
      // });
      return;
    }

    // Check file count
    if (uploadedFiles.length > 5) {
      // setAlert({
      //   alertMessage: "Too many files. Maximum 5 images allowed.",
      //   alertVisible: true,
      //   alertType: "error",
      // });
      return;
    }

    // Check file sizes (50MB limit per file)
    const maxFileSize = 50 * 1024 * 1024; // 50MB
    const oversizedFiles = uploadedFiles.filter((file) => file.size > maxFileSize);

    if (oversizedFiles.length > 0) {
      // setAlert({
      //   alertMessage: `File(s) too large: ${oversizedFiles.map((f) => f.name).join(", ")}. Maximum size is 50MB per file.`,
      //   alertVisible: true,
      //   alertType: "error",
      // });
      return;
    }

    // Validate image types
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/webp"];
    const invalidFiles = uploadedFiles.filter((file) => !allowedTypes.includes(file.type));

    if (invalidFiles.length > 0) {
      // setAlert({
      //   alertMessage: `Invalid file type: ${invalidFiles.map((f) => f.name).join(", ")}. Allowed: JPG, JPEG, PNG, GIF, WebP`,
      //   alertVisible: true,
      //   alertType: "error",
      // });
      return;
    }

    // Create form data as per API requirements
    const formData = new FormData();
    formData.append("serviceRequestId", serviceRequestId);
    formData.append("message", commentText.trim() || ""); // Required field (can be empty)
    const mentionIds = getMentionIds(commentText.trim() || "");
    if (mentionIds.length) formData.append("mentionIds", JSON.stringify(mentionIds));

    // Add image files with correct field name 'commentImages'
    uploadedFiles.forEach((file, index) => {
      formData.append("commentImages", file); // API expects 'commentImages' field
    });

    // For debugging - check what's being sent
    console.log("Uploading images:", {
      serviceRequestId,
      message: commentText.trim() || "(empty)",
      fileCount: uploadedFiles.length,
      files: uploadedFiles.map((f) => ({ name: f.name, type: f.type, size: f.size })),
    });

    mutate(formData, {
      onSuccess: (response) => {
        console.log("Images uploaded successfully:", response);

        // Reset all states
        setImageModal(false);
        setUploadedFiles([]);
        setCommentText("");
        setScrollToBottomTrigger(true);

        // Refresh comments list
        queryClient.invalidateQueries({
          queryKey: ["serviceComment", serviceRequestId],
        });

        // Show success message
        // setAlert({
        //   alertMessage: uploadedFiles.length === 1 ? "Image uploaded successfully" : `${uploadedFiles.length} images uploaded successfully`,
        //   alertVisible: true,
        //   alertType: "success",
        // });
      },
      onError: (error) => {
        console.error("Error uploading images:", error);

        let errorMessage = "Error uploading images";

        if (error.response) {
          // Server responded with error
          console.error("Server error:", error.response.data);
          errorMessage = error.response.data?.message || errorMessage;
        } else if (error.request) {
          // Request was made but no response
          console.error("No response received:", error.request);
          errorMessage = "No response from server. Please check your connection.";
        } else {
          // Something else happened
          console.error("Error:", error.message);
          errorMessage = error.message || errorMessage;
        }

        // setAlert({
        //   alertMessage: errorMessage,
        //   alertVisible: true,
        //   alertType: "error",
        // });
      },
    });
  };

  // Start recording
  const startRecording = async () => {
    let stream;
    try {
      stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    } catch (err) {
      console.error("Mic access denied:", err);
      props.setStartRecording?.(false);
      // setAlert({
      //   alertType: "warning",
      //   alertMessage: "please connect your microphone",
      //   alertVisible: true,
      // });
      alert("please connect your microphone");
      return;
    }

    const recorder = new MediaRecorder(stream);
    let chunks = [];

    recorder.ondataavailable = (event) => {
      if (event.data.size > 0) {
        chunks.push(event.data);
      }
    };

    recorder.onstop = () => {
      if (chunks.length === 0) return;
      const audioBlob = new Blob(chunks, { type: "audio/webm" });
      const audioFile = new File([audioBlob], "recording.webm", {
        type: "audio/webm",
      });
      setRecordedAudio(audioFile);
      setIsRecordingFinished(true);
    };

    recorder.start();
    setMediaRecorder(recorder);
    setIsRecording(true);
    setRecordingTime(0);
    timerRef.current = setInterval(() => {
      setRecordingTime((prev) => prev + 1);
    }, 1000);
  };

  // Stop recording
  const stopRecording = () => {
    if (mediaRecorder) {
      mediaRecorder.stop();
      setIsRecording(false);
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  const handleMicClick = () => {
    if (isRecording) {
      stopRecording();
    } else {
      startRecording();
    }
  };

  useImperativeHandle(ref, () => ({
    handleMicFunction: handleMicClick,
    getCommentText: () => commentText,
    setCommentText: (text) => setCommentText(text),
    getAudioBlob: () => recordedAudio,
    isRecording: isRecording,
  }));

  // Reset state after sending or cancelling
  const resetRecording = () => {
    setRecordedAudio(null);
    setIsRecordingFinished(false);
    setRecordingTime(0);
    setMediaRecorder(null);
  };

  // Send recorded audio
  const handleSendRecording = () => {
    const isCommentAPI = mode === "audio";
    const formData = new FormData();
    
    props.setRecordedBlobData?.(recordedAudio);
    if (isCommentAPI) {
      if (!recordedAudio) return;

      if (skipVoiceS3Upload) {
        props.setRecordedData?.(URL.createObjectURL(recordedAudio));
        props.setStartRecording?.(false);
        props.setAudioPlayer?.(true);
        resetRecording();
        return;
      }

      formData.append("files", recordedAudio);

      generateS3link(formData, {
        onSuccess: (data) => {
          const audioUrl = data?.data?.[0]?.location || URL.createObjectURL(recordedAudio);

          // localStorage.setItem("recordedAudio", audioUrl);

          props.setRecordedData?.(audioUrl);
          props.setStartRecording?.(false);
          props.setAudioPlayer?.(true);
          resetRecording();
        },
        onError: () => {
          alert("Failed to send audio");
        },
      });

      return; // ⛔ IMPORTANT
    } else {
      formData.append("serviceRequestId", serviceRequestId);
      // formData.append("message", ""); // ✅ Add empty message if no text
      formData.append("commentAudio", recordedAudio);

      mutate(formData, {
        onSuccess: (response) => {
          console.log("Audio sent successfully:", response);
          setScrollToBottomTrigger(true);
          queryClient.invalidateQueries({
            queryKey: ["serviceComment", serviceRequestId],
          });

          // Show success message
          // setAlert({
          //   alertMessage: "Audio sent successfully",
          //   alertVisible: true,
          //   alertType: "success",
          // });
        },
        onError: (error) => {
          console.error("Failed to send audio:", error);
          console.error("Error response:", error.response?.data);

          // Show error message
          // setAlert({
          //   alertMessage: error.response?.data?.message || "Failed to send audio",
          //   alertVisible: true,
          //   alertType: "error",
          // });
        },
      });
    }

    resetRecording();
  };

  // Cancel recording
  const handleCancelRecording = () => {
    setOpenDelete(!openDelete);
  };

  // Derive mentioned user/client ids straight from the final text (handles edits/deletions correctly)
  const getMentionIds = (text) => {
    return (props?.commentUser || [])
      .filter((u) => {
        if (!u?.fullName || !u?._id) return false;
        const escaped = u.fullName.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        return new RegExp(`@${escaped}\\b`).test(text);
      })
      .map((u) => u._id);
  };

  // Handle sending text message
  const handleSendMessage = () => {
    const formData = new FormData();
    // 🔹 SERVICE COMMENT
    if (isSending || !commentText.trim()) return;

    setIsSending(true);

    formData.append("serviceRequestId", serviceRequestId);
    formData.append("message", commentText.trim());
    const mentionIds = getMentionIds(commentText.trim());
    if (mentionIds.length) formData.append("mentionIds", JSON.stringify(mentionIds));

    mutate(formData, {
      onSuccess: () => {
        setCommentText("");
        queryClient.invalidateQueries({
          queryKey: ["serviceComment", serviceRequestId],
        });

        setTimeout(() => {
          setScrollToBottomTrigger(true);
        }, 100);

        setIsSending(false);
      },
      onError: () => {
        setIsSending(false);
      },
    });
  };

  const getInitials = (name = "") => {
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase();
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);

    if (!files || files.length === 0) return;

    // Check total file count
    const totalFiles = uploadedFiles.length + files.length;
    if (totalFiles > 5) {
      // setAlert((prev) => ({
      //   ...prev,
      //   alertMessage: "Maximum 5 files allowed",
      //   alertVisible: true,
      // }));
      return;
    }

    // Validate file types
    const validTypes = ["image/png", "image/jpeg", "image/jpg", "video/mp4", "video/webm", "video/quicktime"];

    const invalidFiles = files.filter((file) => !validTypes.includes(file.type));
    if (invalidFiles.length > 0) {
      // setAlert((prev) => ({
      //   ...prev,
      //   alertMessage: `Invalid file type: ${invalidFiles.map((f) => f.name).join(", ")}. Allowed: Images (PNG, JPEG, JPG) and Videos (MP4, WebM, MOV)`,
      //   alertVisible: true,
      // }));
      return;
    }

    // Check file sizes (50MB limit)
    const maxSize = 50 * 1024 * 1024; // 50MB
    const oversizedFiles = files.filter((file) => file.size > maxSize);
    if (oversizedFiles.length > 0) {
      // setAlert((prev) => ({
      //   ...prev,
      //   alertMessage: `Files too large: ${oversizedFiles.map((f) => f.name).join(", ")}. Max size is 50MB`,
      //   alertVisible: true,
      // }));
      return;
    }

    // Check if mixing images and videos
    const existingTypes = uploadedFiles.map((f) => (f.type.startsWith("image/") ? "image" : "video"));
    const newTypes = files.map((f) => (f.type.startsWith("image/") ? "image" : "video"));
    const allTypes = [...existingTypes, ...newTypes];

    const hasImages = allTypes.includes("image");
    const hasVideos = allTypes.includes("video");

    if (hasImages && hasVideos) {
      // setAlert((prev) => ({
      //   ...prev,
      //   alertMessage: "You can only upload either all images or all videos, not both.",
      //   alertVisible: true,
      // }));
      return;
    }

    // Add files to state
    setUploadedFiles((prev) => [...prev, ...files]);

    // Optionally close modal if we have files
    if (uploadedFiles.length + files.length > 0) {
      // You can choose to close the modal or keep it open for more uploads
      // setImageModal(false);
    }
  };

  const handleDeleteImg = (index) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  // Adjust textarea height dynamically
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      const lineHeight = parseInt(getComputedStyle(textareaRef.current).lineHeight);
      const maxHeight = 5 * lineHeight;
      const scrollHeight = textareaRef.current.scrollHeight;

      textareaRef.current.style.height = `${Math.min(scrollHeight, maxHeight)}px`;

      if (commentText.trim() && scrollHeight > prevHeightRef.current) {
        setTrackHeight(true);
      } else if (!commentText.trim() || scrollHeight <= lineHeight * 1.5) {
        setTrackHeight(false);
      }

      prevHeightRef.current = scrollHeight;
    }
  }, [commentText]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        textareaRef.current &&
        !textareaRef.current.contains(e.target) &&
        !document.querySelector(".mention-dropdown")?.contains(e.target) &&
        !document.querySelector(".emoji-dropdown")?.contains(e.target)
      ) {
        setShowMentionBox(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (onRecordingChange) {
      onRecordingChange(isRecording);
    }
  }, [isRecording, onRecordingChange]);

  return (
    <>
      <div style={{ display: "flex", alignItems: "end", gap: "13px" }}>
        <div className="comment-box-2" style={{ flexGrow: 1 }}>
          {isFileUpload && (
            <span
              style={{
                height: "30px",
                width: "30px",
                display: recordingTime ? "none" : "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: trackHeight && "28px",
                cursor: "pointer",
                color:"#000000",
                fontSize:"28px"
              }}
              onClick={() => setImageModal(true)}
            >
              {/* <BlackPlus /> */}
              {"+"}
            </span>
          )}
          {isRecordingFinished && recordedAudio ? (
            <div
              className="audio2"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                width: "100%",
              }}
            >
              <audio style={{ flexGrow: 1, height: "40px" }} controls src={URL.createObjectURL(recordedAudio)} controlsList="nodownload noplaybackrate" />
              <div style={{ position: "relative" }}>
                <button
                  style={{
                    border: "none",
                    padding: 10,
                    borderRadius: "50%",
                    display: "flex",
                    cursor: "pointer",
                  }}
                  className="audio2Cancel"
                  onClick={handleCancelRecording}
                >
                  {/* {newGetIcons("close")} */}
                  {"X"}
                </button>
              </div>
            </div>
          ) : (
            <div
              style={{
                width: "100%",
                display: "flex",
                position: "relative",
              }}
            >
              <div
                style={{
                  position: "relative",
                  flexGrow: 1,
                  display: "flex",
                }}
              >
                <textarea
                  type="text"
                  placeholder={
                    isSending ? "Sending..." : recordingTime ? `${runingFormatTime(recordingTime)} Recording ...` : hidePlaceholder ? "" : "Type a comment"
                  }
                  ref={textareaRef}
                  style={{
                    flexGrow: 1,
                    fontSize: "14px",
                    borderRadius: "30px",
                    backgroundColor: recordingTime ? "pink" : "#8B8B8B33",
                    resize: "none",
                    minHeight: "40px",
                    maxHeight: "200px",
                    overflowY: "auto",
                    lineHeight: "1.2",
                    width: "100%",
                    position: "relative",
                    zIndex: 1,
                  }}
                  rows={1}
                  value={commentText}
                  readOnly={isRecordOnly}
                  onClick={() => {
                    setShowMentionBox(false);
                  }}
                  onFocus={(e) => {
                    const cursorPos = e.target.selectionStart;
                    const text = commentText;
                    const textTillCursor = text.slice(0, cursorPos);
                    const match = textTillCursor.match(/@(\w*)$/);
                    if (match) {
                      setMentionSearch(match[1]);
                      setShowMentionBox(true);
                    }
                  }}
                  onChange={(e) => {
                    if (isRecordOnly) return;
                    const value = e.target.value;
                    setCommentText(value);

                    const cursorPos = e.target.selectionStart;
                    const textTillCursor = value.slice(0, cursorPos);

                    // Check for mentions with @
                    const mentionMatch = textTillCursor.match(/@(\w*)$/);
                    if (mentionMatch) {
                      setMentionSearch(mentionMatch[1]);

                      const result = props?.commentUser?.filter((u) => u?.fullName?.toLowerCase()?.includes(mentionMatch[1]?.toLowerCase())) || [];

                      setMentionList(result);
                      setShowMentionBox(result.length > 0);
                    } else {
                      setShowMentionBox(false);
                    }
                  }}
                  onKeyDown={(e) => {
                    // Mention dropdown navigation
                    if (showMentionBox && mentionList?.length > 0) {
                      if (e.key === "ArrowDown") {
                        e.preventDefault();
                        setSelectedMentionIndex((prev) => (prev < mentionList.length - 1 ? prev + 1 : prev));
                      } else if (e.key === "ArrowUp") {
                        e.preventDefault();
                        setSelectedMentionIndex((prev) => (prev > 0 ? prev - 1 : prev));
                      } else if (e.key === "Enter") {
                        e.preventDefault();
                        if (selectedMentionIndex >= 0) {
                          const u = mentionList[selectedMentionIndex];
                          const end = textareaRef.current.selectionStart;
                          let text = commentText;
                          const start = text.lastIndexOf("@");
                          const nameWithAt = `@${u?.fullName}`;
                          const mentionPattern = new RegExp(`@${u?.fullName}\\b`, "g");
                          const existingMentions = text.match(mentionPattern);

                          if (existingMentions && existingMentions.length > 0) {
                            setShowMentionBox(false);
                            // setAlert({
                            //   alertType: "warning",
                            //   alertMessage: `${u.fullName} already mentioned`,
                            //   alertVisible: true,
                            // });
                            return;
                          }

                          const newText = text.substring(0, start) + nameWithAt + " " + text.substring(end);

                          setCommentText(newText);
                          setShowMentionBox(false);
                          setSelectedMentionIndex(-1);
                        }
                      }
                    }

                    // Regular Enter key for sending message
                    else if (e.key === "Enter" && !e.shiftKey && commentText.trim()) {
                      e.preventDefault();
                      handleSendMessage();
                    }
                  }}
                />
              </div>
              {showMentionBox && mentionList?.length > 0 && (
                <div className="mention-dropdown">
                  {mentionList?.map((u, i) => (
                    <div
                      key={i}
                      ref={selectedMentionIndex === i ? (el) => el?.scrollIntoView({ block: "nearest" }) : null}
                      className="mention-option"
                      onClick={() => {
                        const end = textareaRef.current.selectionStart;
                        let text = commentText;
                        const start = text.lastIndexOf("@");

                        const nameWithAt = `@${u?.fullName}`;

                        const mentionPattern = new RegExp(`@${u?.fullName}\\b`, "g");
                        const existingMentions = text.match(mentionPattern);

                        if (existingMentions && existingMentions.length > 0) {
                          setShowMentionBox(false);
                          // setAlert({
                          //   alertType: "warning",
                          //   alertMessage: `${u.fullName} already mentioned`,
                          //   alertVisible: true,
                          // });
                          return;
                        }

                        const newText = text.substring(0, start) + nameWithAt + " " + text.substring(end);

                        setCommentText(newText);
                        setShowMentionBox(false);
                      }}
                      style={{
                        backgroundColor: selectedMentionIndex === i ? "#e8f5e9" : "transparent",
                        cursor: "pointer",
                        padding: "8px 12px",
                        transition: "background-color 0.2s",
                      }}
                    >
                      {u?.profileImage ? <img src={u?.profileImage} alt="" /> : <div className="mention-initials">{getInitials(u?.fullName)}</div>}
                      {u?.fullName}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
        <span
          className="comment-icon-two"
          style={{
             display:
              ((commentText.trim() || isRecordingFinished) && hideSend) ||
              (mode === "audio" &&
                !commentText.trim() &&
                !isRecordingFinished &&
                !isRecording)
                ? "none"
                : "flex",
          }}
        >
          {commentText.trim() || isRecordingFinished ? (
            <IconButton
              onClick={() => {
                if (isRecordingFinished && recordedAudio) {
                  handleSendRecording();
                } else {
                  handleSendMessage();
                }
              }}
            >
              {isSending ? (
                <CircularProgress
                  size="30px"
                  thickness={4}
                  sx={{ color: "#d3d3d3" }}
                  slotProps={{
                    track: {
                      sx: { stroke: "#f0f0f0" },
                    },
                  }}
                />
              ) : (
                <SendIcon />
              )}
            </IconButton>
          ) : isRecording ? (
            <IconButton sx={{ color: "black" }} onClick={handleMicClick}>
              X
            </IconButton>
          ) : mode === "audio" ? null : (
            <IconButton sx={{ color: "black" }} onClick={handleMicClick}>
              {getIcon("MicIcon")}
            </IconButton>
          )}
        </span>
      </div>

      <MesaageModal
        open={openDelete}
        handleClose={handleCancelRecording}
        style={{
          minHeight: "172px",
          width: "fit-content",
          padding: "30px 20px",
          borderRadius: "5px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "40px",
          }}
        >
          <p
            style={{
              fontFamily: "Poppins",
              fontWeight: 500,
              fontSize: "18px",
              lineHeight: "22px",
              letterSpacing: "-0.41px",
              whiteSpace: "nowrap",
              textAlign: "center",
            }}
          >
            Do you want to keep this recording?
          </p>
          <div style={{ display: "flex", gap: "48px" }}>
            <button
              onClick={() => {
                resetRecording();
                setOpenDelete(false);
                props.setRecordedData?.(false);
                props.setRecordedBlobData?.(null);
                props.setAudioPlayer?.(false);
                props.setStartRecording?.(false);
              }}
              style={{
                height: "50px",
                minWidth: "173px",
                backgroundColor: "#E77B7B",
                borderRadius: "5px",
                border: "none",
                fontFamily: "Poppins",
                fontWeight: 500,
                fontSize: "14px",
                lineHeight: "22px",
                letterSpacing: "-0.41px",
                cursor: "pointer",
              }}
            >
              No
            </button>
            <button
              onClick={() => setOpenDelete(false)}
              style={{
                height: "50px",
                minWidth: "173px",
                backgroundColor: "#50C878",
                borderRadius: "5px",
                border: "none",
                fontFamily: "Poppins",
                fontWeight: 500,
                fontSize: "14px",
                lineHeight: "22px",
                letterSpacing: "-0.41px",
                cursor: "pointer",
              }}
            >
              Yes, Keep
            </button>
          </div>
        </div>
      </MesaageModal>

      <Modal open={imageModal} onClose={() => setImageModal(false)}>
        
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              outline: "none",
              background: "#101010",
            }}
          >
            {uploadedFiles.length === 0 ? (
              <>
                <div style={{ padding: "20px 30px", display: "flex", flexDirection: "column" }}>
                  <div style={{ display: "flex", color: "white", justifyContent: "flex-start", alignItems: "flex-start", height: "40px", position: "relative" }}>
                    <span style={{ position: "absolute", right: "-4px", top: "-6px", cursor: "pointer" }} onClick={() => setImageModal(false)}>
                      <BigCrossIcon />
                    </span>
                    <p style={{ margin: 0, padding: 0, paddingBottom: "12px", fontSize: "18px", fontWeight: 500, fontFamily: "Poppins" }}>Image Upload</p>
                  </div>
                  <FileContainerComp fileheight={"543px"} handleFileChange={handleFileChange} />
                </div>
              </>
            ) : (
              <TableContainerComp
                selectedFiles={uploadedFiles}
                setSelectedFiles={setUploadedFiles}
                handleFileChange={handleFileChange}
                onClose={() => setImageModal(false)}
                handleDeleteImg={handleDeleteImg}
                AddImagesBtn={true}
                submitBtnName={"Upload"}
                handleSubmitBtn={handleImageSumbit}
                isEditIcon={false}
              />
            )}
          </div>
       
      </Modal>

      {/* <UploadImageModal
          open={imageModal}
          onClose={() => {
            setUploadedFiles([])
            setImageModal(false)
          }}
          setFiles={setUploadedFiles}
          files={uploadedFiles}
          uploadLabel="Upload Images  |  Drag & Drop  |  Browse Files"
          title="Upload File"
          submitBtnTitle="Upload"
          multiple={true}
          accept={"image/png, image/jpeg, image/jpg ,video/mp4, video/webm"}
          onSubmit={handleImageSumbit}
          isLoading={isPending}
        /> */}
    </>
  );
});

export default CommentComp;
